<template>
<div id="banner">
  <div class="container">
    <div class="banner-contaier">
      <div class="logo">
        <div class="icon">
          <img src="@/assets/img/lingdongliang@2x.png" alt="logo"  @click="toCourseList"/>
        </div>
      </div>
      <div class="tab-type flex-center">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="选课中心" name="CourseList" v-if="!hideCourseTab"></el-tab-pane>
          <el-tab-pane label="讲座" name="Lecture"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="logout" v-if="isLogin">
        <router-link tag="div" class="my_class" :to="{ name: 'MyCourse'}">我的课程</router-link>
        <div
          class="phone-number flex-center float-right hidden-xs"
        >{{userInfo.mobile&&userInfo.mobile.toString().substring(0,3)+'****'+userInfo.mobile.toString().substring(7,11)}}</div>
        <el-dropdown @command="handleCommand" @visible-change="visibleChange">
          <div class="user-info">
            <div class="userimg">
              <img src="../../assets/img/crown@2x.png" alt="" class="crown" v-if="userInfo.is_vip_plus">
              <img :src="userInfo.avatar" alt="" >
            </div>
            <div class="icon_down" :style="down_list?'transform: rotate(180deg);transition: 0.4s;':'transition: 0.4s;'">
              <i class="fa fa-xiala"></i>
            </div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="vip" v-if="userInfo.is_vip_plus">我的会员</el-dropdown-item>
            <el-dropdown-item :divided="userInfo.is_vip_plus" command="order">我的订单</el-dropdown-item>
            <el-dropdown-item divided command="coupon">我的礼券</el-dropdown-item>
            <el-dropdown-item divided command="protons">质子管理</el-dropdown-item>
            <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="login" v-if="!isLogin">
        <el-button type="primary" @click="goLogin">立即登录</el-button>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import banner from './banner'
export default {
  mixins: [banner],
  data () {
    return {
      hideCourseTab: Number(process.env.VUE_APP_HIDE_COURSE_TAB) === 1
    }
  }
}
</script>

<style  lang="scss" scoped>
@import "@/assets/scss/_base.scss";

.flex-center {
  display: flex;
  justify-items: center;
  align-items: center;
}
.hand {
  cursor: pointer;
}
#banner {
  height: 48px;
  background: $pagination-bg;
  border-radius: 2px;
  align-items: center;
  .container {
    height: 100%;
  }
  .banner-contaier {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    .logo {
      display: flex;
      width: 10%;
      cursor: pointer;
      .icon {
        width: 92px;
        height: 25px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .tab-type {
      width: 50%;
      justify-content: left;
      ::v-deep .el-tabs__header {
        margin: 0;
      }
      :after {
        display: none;
      }
    }
    .logout {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 100%;
      width: 33%;
      position: relative;
      .down_list{
        position: absolute;
        width: 132px;
        height: 109px;
        box-sizing: border-box;
        background: $pagination-bg;
        box-shadow:0px 4px 16px 0px rgba(172,183,195,0.15);
        border-radius:4px;
        border:1px solid rgba($base-color,0.06);
        top: 48px;
        right: -28px;
        @media screen and(max-width: 786px){
          right: 0;
        }
        div{
          height: 54px;
          width: 100px;
          text-align: center;
          margin: auto;
          line-height: 54px;
          font-size:14px;
          font-weight:400;
        }
        div:nth-child(1){
          border-bottom: 1px solid rgba($base-color,0.08);
        }
        div:hover {
          color: $brand-success;
          cursor: pointer;
        }
      }
      .icon_down{
        font-size: 12px;
        color: $gray-light;
      }
      .my_class{
        padding: 0px 16px;
        border-right: 1px solid $gray-lighter;
        margin-right: 16px;
        cursor: pointer;
      }
      .user-info{
        cursor: pointer;
        display: flex;
        align-items: center;
        height: 100%;
      }
      .userimg{
        width: 30px;
        height: 30px;
        border-radius: 50%;
        // background: skyblue;
        margin: 0px 9px 0px 16px;
        position: relative;
        img{
           width: 30px;
           height: 30px;
           border-radius: 50%;
        }
        .crown{
          width: 18px;
          height: 12px;
          position: absolute;
          top: -7px;
          left: 16px;
          transform:rotate(28deg);
          -webkit-transform:rotate(28deg);
          -moz-transform:rotate(28deg);
        }
      }
      .phone-number {
        font-size: 14px;
        font-weight: 400;
        color: $base-color;
      }
      .logout-text {
        margin-left: 20px;
        font-size: 14px;
        font-weight: 400;
        color: $gray;
      }
      .logout-icon {
        width: 14px;
        height: 15px;
        margin-left: 5px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .login {
      width: 33%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
@media (max-width: 1372px) and (min-width: 768px){
#banner .banner-contaier .logout {
  width: 37%;
}
}
</style>
